import { BalanceManager } from "./../balanceManager";

export class requestBalance{
    private requestBalanceUrl = (window as any).GENERAL_CONFIG.requestBalanceInterval.url || "";
    private requestBalanceIntervalTime = (window as any).GENERAL_CONFIG.requestBalanceInterval.time
    private requestBalanceEndpoint = "";
    private requestBalanceTimer: ReturnType<typeof setInterval> | null = null;

    
    constructor(private params: any){

    }

    public getEncodedLaunchingUrl(): string {
        return (this.params.location) ? encodeURIComponent(this.params.location) : "";
    }
    private resolveRequestBalanceEndpoint(): string {
        if (!this.requestBalanceUrl) return "";

        //Prende la location e la sostituisce nell'url passato
        const encodedLaunchingUrl = this.getEncodedLaunchingUrl();
        return this.requestBalanceUrl.replace("{encodedLaunchingUrl}", encodedLaunchingUrl);
    }

    public requestBalancePingStart(): void{
        this.requestBalanceEndpoint = this.resolveRequestBalanceEndpoint();
        if(!this.requestBalanceEndpoint || this.requestBalanceIntervalTime <= 0) return;

        if (this.requestBalanceTimer) return;
        
        this.balancePingSend();

        this.requestBalanceTimer = setInterval(() => {
            this.balancePingSend();
        }, this.requestBalanceIntervalTime);
    }

    public async balancePingSend(): Promise<void> {
        if ((window as any).Game?.paused) return;
        if (!this.requestBalanceEndpoint) return;

        try {
            const response = await fetch(this.requestBalanceEndpoint, {
                method: "GET"
            });

            if (!response.ok) {
                console.warn("balancePing non ok:", response.status);
                return;
            }

            const xmlText = await response.text();
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xmlText, "text/xml");

            const balanceElement = xmlDoc.getElementsByTagName("balance")[0];
            const balanceText = balanceElement?.textContent ?? "";
            const balance = parseInt(balanceText, 10);

            if (!Number.isNaN(balance) && balance > 0) {
                BalanceManager.set(balance);

                (window as any).UIBridge?.setBalance(
                    (window as any).FORMATTER.formatCurrency(balance, true)
                );
            }
        } catch (e) {
            console.warn("Errore balancePing", e);
        }
    }

    public requestBalancePingStop(): void {
        if (this.requestBalanceTimer) {
            clearInterval(this.requestBalanceTimer);
            this.requestBalanceTimer = null;
        }
    }
}